//学生进老师直播间下方显示nav
// ?is_promote_flag=true 参数说明，渠道要求带这个参数去"我的"会适当做一些内容隐藏
import React from 'react'
import {browserHistory}  from 'react-router'
import {Dialog} from 'react-weui'
import {connect} from 'react-redux'
import '../../styles/liveroom/LiveroomBottomStudentNav.css'

class LiveroomBottomStudentNav extends React.Component {
    constructor() {
        super()
        this.state = {
            NormalDialogBtns: [
                {
                    type: 'primary',
                    label: '好的',
                    onClick: () => {this.setState({showNormalDialog: false})}
                },
            ],
            showNormalDialog: false,
        }
    }
    render() {
        const {is_promote_flag} = this.props
        const qrcode = this.props.liveroom.liveroom.custom_qrcode_url
        return (
            <div className="LiveroomBottomStudentNav">

                <Dialog type="ios" buttons={this.state.NormalDialogBtns} show={this.state.showNormalDialog}>
                    <div className="BottomStudentNavShowQrcode">
                        <p>长按扫码立即关注</p>
                        <img style={{width: '50%', marginTop: 10}} src={qrcode} alt=""/>
                    </div>
                </Dialog>

                <div className="BottomStudentNav_item" onClick={() => {this.setState({showNormalDialog:true})}}>
                    <div className="BottomStudentNav_item_content">
                        <img src="https://static-1253442168.image.myqcloud.com/picture/9965163_f693fe32577fb7a584e58a97c0fedc37.jpg-picmsg420" alt=""/>
                        公众号
                    </div>
                </div>
                <div className="BottomStudentNav_item"  onClick={()=>{location.assign(`/account/${is_promote_flag ? '?is_promote_flag=true' : ''}`)}}>
                    <div className="BottomStudentNav_item_content">
                        <img src="https://static-1253442168.image.myqcloud.com/picture/8173011_34f35484e27797864c637670be66959d.jpg-picmsg420" alt=""/>
                        我的
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    liveroom: state.liveroom,
}))(LiveroomBottomStudentNav)


// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomBottomStudentNav.js